
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@shared/ui/dialog";
import { ScrollArea } from "@shared/ui/scroll-area";
import { Badge } from "@shared/ui/badge";
import { Drawer, DrawerContent, DrawerHeader, DrawerTitle } from "@shared/ui/drawer";
import { useMediaQuery } from "@shared/hooks/useMediaQuery";

interface LogsModalProps {
  isOpen: boolean;
  onClose: () => void;
  idName: string;
}

const LogsModal = ({ isOpen, onClose, idName }: LogsModalProps) => {
  const isMobile = useMediaQuery("(max-width: 640px)");
  
  // Sample logs data - in a real app, this would be fetched from an API
  const logs = [
    {
      id: 1,
      action: "Created",
      timestamp: "2024-04-01 09:15:22",
      user: "Alex Smith",
      details: "Initial configuration"
    },
    {
      id: 2,
      action: "Updated",
      timestamp: "2024-04-02 14:30:45",
      user: "Jordan Lee",
      details: "Changed prefix from CST to CUST"
    },
    {
      id: 3,
      action: "Updated",
      timestamp: "2024-04-03 11:05:12",
      user: "Casey Johnson",
      details: "Modified sequence length from 3 to 4"
    }
  ];

  const getActionColor = (action: string) => {
    switch (action) {
      case "Created":
        return "bg-green-100 text-green-800";
      case "Updated":
        return "bg-blue-100 text-blue-800";
      case "Deleted":
        return "bg-red-100 text-red-800";
      default:
        return "bg-gray-100 text-gray-800";
    }
  };

  const content = (
    <div className="space-y-4">
      {logs.map(log => (
        <div key={log.id} className="border-l-2 border-blue-500 pl-4 py-3 bg-white rounded-md shadow-sm">
          <div className="flex justify-between text-sm items-start">
            <Badge className={getActionColor(log.action)}>{log.action}</Badge>
            <span className="text-muted-foreground">{log.timestamp}</span>
          </div>
          <p className="text-muted-foreground text-sm mt-2">{log.details}</p>
          <p className="text-xs mt-1 text-muted-foreground">By {log.user}</p>
        </div>
      ))}
    </div>
  );

  if (isMobile) {
    return (
      <Drawer open={isOpen} onOpenChange={(open) => !open && onClose()}>
        <DrawerContent className="max-h-[85vh]">
          <DrawerHeader>
            <DrawerTitle>Activity Logs: {idName}</DrawerTitle>
          </DrawerHeader>
          <div className="px-4 pb-6">
            {content}
          </div>
        </DrawerContent>
      </Drawer>
    );
  }

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="sm:max-w-[700px] max-h-[90vh]">
        <DialogHeader>
          <DialogTitle>Activity Logs: {idName}</DialogTitle>
        </DialogHeader>
        
        <ScrollArea className="h-[500px] pr-4">
          {content}
        </ScrollArea>
      </DialogContent>
    </Dialog>
  );
};

export default LogsModal;
